import Fuse from 'fuse.js';
import { GroupBase } from 'chakra-react-select';

export type DropdownOption = {
  label: string;
  value: string;
  source: string;
  table: string;
};

export type DropdownGroup = GroupBase<DropdownOption>;

/**
 * Groups options into "Suggested" and "All campaigns" using Fuse.js fuzzy matching
 */
export function groupOptionsWithSuggestions(
  options: DropdownOption[],
  campaignName: string,
): DropdownGroup[] {
  const fuse = new Fuse(options, {
    keys: ['label'],
    threshold: 0.4,
    includeScore: true,
  });

  const searchResults = fuse.search(campaignName);
  const suggestedOptions = searchResults
    .slice(0, 5) // get only top 5 suggestions
    .map((result) => result.item);

  const suggestedIds = new Set(suggestedOptions.map((opt) => opt.value));
  const otherOptions = options.filter((opt) => !suggestedIds.has(opt.value));

  return [
    ...(suggestedOptions.length > 0
      ? [{ label: 'Suggested', options: suggestedOptions }]
      : []),
    { label: 'All campaigns', options: otherOptions },
  ];
}
